import React from "react";
import {Story} from "../../types";
import {Image, StyleSheet, View, useWindowDimensions} from "react-native";
import { getCardBorderRadius, getCardBorderWidth } from "../../utils/spacing";

type CardProps = {
    story: Story;
    selected: boolean;
};

const Card: React.VFC<CardProps> = ({ story, selected}) => {
    const { background, video } = story;
    const { width } = useWindowDimensions();

    const borderRadius = getCardBorderRadius(width);
    const borderWidth = getCardBorderWidth(width);

    return (
        <View style={[styles.card, {
            borderColor: (selected ? "#000" : background),
            borderRadius,
            borderWidth,
        }]}>
            <Image source={{ uri: video.placeholder}} style={styles.image} />
        </View>
    )
};

const styles = StyleSheet.create({
    card: {
        backgroundColor: "#000",
        borderStyle: "solid",
        // borderWidth and borderRadius are now applied inline for responsive behavior
        height: "100%",
        overflow: "hidden"
    },
    image: {
        width: "100%",
        height: "100%",
    }
});

export default Card;